import React, { useState } from "react";
import { NavLink } from "react-router-dom";

const Menu = () => {
  const [open, setOpen] = useState(false);

  const links = [
    { to: "/", label: "Home", exact: true },
    { to: "/experiencia", label: "Experiencia" },
    { to: "/formacion", label: "Formación" },
    { to: "/conocimientosBD", label: "BBDD" },
    { to: "/conocimientosLenguaje", label: "Lenguajes" },
    { to: "/otrosConocimientos", label: "Otros" },
  ];

  return (
    <header className="navWrap">
      <div className="navPill">
        <div className="navBrand">
          <span className="navName">Jose A. Navas</span>
          <span className="navRole">Responsable IT / .NET Senior</span>
        </div>

        <nav className="navLinks" aria-label="Navegación principal">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              exact={l.exact}
              className="navLink"
              activeClassName="isActive"
              onClick={() => setOpen(false)}
            >
              {l.label}
            </NavLink>
          ))}

          <a className="navCta" href="/cv.pdf" target="_blank" rel="noreferrer">
            CV PDF
          </a>
        </nav>

        <button
          className="navBurger"
          type="button"
          aria-label="Abrir menú"
          aria-expanded={open ? "true" : "false"}
          onClick={() => setOpen((v) => !v)}
        >
          <span />
          <span />
          <span />
        </button>
      </div>

      {open && (
        <div className="navMobile">
          <div className="navMobilePanel" role="dialog" aria-label="Menú móvil">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                exact={l.exact}
                className="navMobileLink"
                activeClassName="isActive"
                onClick={() => setOpen(false)}
              >
                {l.label}
              </NavLink>
            ))}

            <a
              className="navMobileCta"
              href="/cv.pdf"
              target="_blank"
              rel="noreferrer"
              onClick={() => setOpen(false)}
            >
              Descargar CV (PDF)
            </a>

            <button className="navMobileClose" type="button" onClick={() => setOpen(false)}>
              Cerrar
            </button>
          </div>

          <div className="navMobileBackdrop" onClick={() => setOpen(false)} />
        </div>
      )}
    </header>
  );
};

export default Menu;
